export const textObj = {
  activity:{
    //活动开头文案
    words:[
      "2014年6月22日，中国大运河成功入选《世界遗产名录》。 2024年，恰逢大运河申遗成功十周年，同时也是京津冀协同发展国家战略提出十周年。为了更好地保护、传承中国大运河历史文化遗产，展现优美的自然人文景观和人民的幸福美好生活，推动京津冀文化协同发展，4月初，『运河光影』暨中国大运河申遗成功十周年京津冀三地主题摄影展作品征集活动正式开始。欢迎广大摄影工作者和摄影爱好者踊跃投稿、积极参与！"
    ],
    //活动二维码
    codeImg:require("../img/m/activity/code.png"),
    //活动跳转地址
    linkUrl:"https://ks.wjx.top/vm/hiV4g7H.aspx",
    prizes:[
      {name:'荣耀手环',level:"一等奖",img:require("../img/common/prize1.png"),num:'1名'},
      {name:'充电宝',level:"二等奖",img:require("../img/common/prize2.png"),num:'3名'},
      {name:'茶盏礼盒',level:"三等奖",img:require("../img/common/prize3.png"),num:'6名'}
    ],
    rules:[
      {title:"一、组织单位",
      value:"<div class=\"line-name\"><span class=\"lable\">主办单位：</span><div class=\"dec\"><span>北京市东城区图书馆</span><span>天津市北辰区图书馆</span><span>河北省沧州市图书馆</span></div></div>"
      +"<div class=\"line-name\"><span  class=\"lable\">承办单位：</span><div  class=\"dec\"><span>北京摄影爱好者协会</span></div></div>"
      +"<div class=\"line-name\"><span  class=\"lable\">协办单位：</span><div  class=\"dec\"><span>中文在线</span></div></div>"
    },
      {title:"二、征集时间",value:"<p class=\"title2\">2024年4月3日至2024年5月15日</p>"},
      {title:"三、活动对象", value:"<p class=\"title2\">面向京津冀三地摄影工作者、摄影爱好者和社会各界人士。</p>",},
      {title:"四、征集内容", value:"<p class=\"title2\">以摄影艺术的形式反映大运河及其沿线风土人情故事，展示大运河丰厚的历史文化遗产、优美的自然人文景观和人民的幸福美好生活。</p>"},
      {title:"五、投稿要求", value:
      "<p class=\"title2\">1.参赛作品应是近些年拍摄的新作品，紧扣活动主题，具有一定的摄影技巧和创意。作品数量不限，单幅或组照（限4幅/组，统一规格），彩色或黑白照片不限。</p>"
      +"<p class=\"title2\">2.本次摄影展征集只收电子版作品，投稿作品需发至指定电子邮箱。</p>"
      +"<p class=\"title2\">3.作品必须是真实原创摄影作品，谢绝使用电脑创意和改变原始影像的作品（仅可以做亮度、对比度、色彩饱和度的适度调整，不能做合成添加、大幅度改变色彩，不得在作品上添加文字、边框等电脑技术处理）。</p>"
      +"<p class=\"title2\">4.摄影作品电子稿件要求为JPEG格式，每幅作品的文件量须大于5MB。投稿者在投稿时写明代表地区：如北京＼天津＼河北，每幅作品文件需注明作者姓名+联系方式+作品标题+拍摄地点，请打包压缩后发送至指定电子邮箱。凡文件量不足或提交的个人信息不全面而影响联络的，都将视为自动放弃参展资格。</p>"
      +"<p class=\"title2\">5.投稿者应保证其为所投送作品的作者，并对该作品的拥有独立、完整的著作权。投稿者还应保证其所投送的作品不侵犯第三人的合法权益（包括著作权、肖像权、名誉权、隐私权等在内）。投稿者应承担由其作品及投稿行为所引发的一切后果与责任，主办方不承担相关连带责任。</p>"
      +"<p class=\"title2\">6.对于入展作品，最终作品著作权归原作者所有，主办单位有权将入选作品用于推广宣传活动（包括但不限于网络、新闻发布或其他媒体、线下展示推广会等活动）、公益展览、展示、复制、出版、发行、公告、宣传、汇编等（保留入展作品摄影师署名权），使用地域不受限制，并允许主办方对作品进行修改和裁切。投稿作品入选后即视为授权主办单位按照上述方式使用。稿酬按照本征稿启示的规则支付，组织单位不再另支付报酬。</p>"
      +"<p class=\"title2\">7.禁止该展的主办单位人员参与，一经发现即取消资格。</p>"
      +"<p class=\"title2\">8.入选作品如有违法、违规情况被举报，一经核实，主办方有权取消其获奖资格并追回获奖证书及奖金。</p>"
      +"<p class=\"title2\">9.本征稿启事解释权属于主办单位。凡投稿者，即视为其已同意本征稿启事的所有规定。</p>"     
  },
  {title:"六、评选原则", value:"<p class=\"title2\">坚持公开、公平、公正的原则，邀请专家组成专家团进行评选，保证公平竞争。</p>"},
  {title:"七、奖项设置", value:
  "<p class=\"title2\">入展作品由主办单位颁发入展证书，稿酬支付工作由北京摄影爱好者协会负责，稿酬300元/幅。</p>"
  +"<p class=\"title2\">本次摄影展评委会、主办方将从京津冀三地征集到的所有作品中最终选取50幅优秀作品，将于6月下旬在京津冀三地同步展览。</p>"
  +"<p class=\"title2\">投稿邮箱：yunheyingzhan@vip.163.com（“运河影展”的全拼）</p>"
  +"<p class=\"title2\">咨询电话：固定电话010-64172387 或手机：13901359444</p>"
},

    ],
  remark:[
    "北京市东城区图书馆",
    "天津市北辰区图书馆",
    "河北省沧州市图书馆"
  ]
  }
}
